import { z } from 'zod';
import { ExtractionQuestionSchema } from '@trinity/chat';

/**
 * Form validation schema that layers form-specific rules (required fields, min items)
 * on top of the existing ExtractionQuestionSchema from @trinity/chat.
 */
export const ExtractionQuestionsFormSchema = z.object({
  questions: z
    .array(ExtractionQuestionSchema)
    .min(1, 'At least one question is required')
    .superRefine((questions, ctx) => {
      questions.forEach((q, i) => {
        if (!q.label.trim()) {
          ctx.addIssue({
            code: 'custom',
            message: 'Label is required',
            path: [i, 'label'],
          });
        }
        if (!q.questionText.trim()) {
          ctx.addIssue({
            code: 'custom',
            message: 'Question text is required',
            path: [i, 'questionText'],
          });
        }
        if ('options' in q && Array.isArray(q.options) && q.options.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: 'At least one option is required',
            path: [i, 'options'],
          });
        }
        if ('ranges' in q && Array.isArray(q.ranges) && q.ranges.length === 0) {
          ctx.addIssue({
            code: 'custom',
            message: 'At least one range is required',
            path: [i, 'ranges'],
          });
        }
        if ('scale' in q && Array.isArray(q.scale) && q.scale.length < 2) {
          ctx.addIssue({
            code: 'custom',
            message: 'At least two scale points are required',
            path: [i, 'scale'],
          });
        }
      });
    }),
});

export type ExtractionQuestionsFormValues = z.infer<typeof ExtractionQuestionsFormSchema>;
